



































































import { Component, Vue, Prop } from 'vue-property-decorator';
import GridComponent from '@/components/GridComponent.vue';
import SlideFilterBoundary from '@/hoc/SlideFilterBoundary.vue';
import { namespace } from 'vuex-class';
import AssetCard from '@/components/AssetCard.vue';
import FilterComponent from '@/components/drawer/FilterComponent.vue';
import Slide from '../interfaces/models/Slide';
import { cloneDeep, findIndex } from 'lodash';
import AssetCardSelectionBoundary from '../hoc/AssetCardSelectionBoundary.vue';
import CartSelectionBoundary from '../hoc/CartSelectionBoundary.vue';
import LazyLoadingComponent from '../components/LazyLoadingComponent.vue';
import { EventBus } from '@/event-bus';
import AssetCardDataBoundary from '../hoc/asset-card/AssetCardDataBoundary.vue';
import CartView from './CartView.vue';
import SortLibComponent from '../components/filter/SortLib.vue';

const lib = namespace('library');
const cart = namespace('cart');

let initialSelectionIndex: number | null = null;

@Component({
  components: {
    grid: GridComponent,
    filterBoundary: SlideFilterBoundary,
    assetCard: AssetCardDataBoundary,
    filterComponent: FilterComponent,
    cardSelectionBoundary: AssetCardSelectionBoundary,
    cartSelectionBoundary: CartSelectionBoundary,
    lazyLoading: LazyLoadingComponent,
    cart: CartView,
    sort: SortLibComponent
  }
})
export default class LibraryView extends Vue {
  private libraryInArchive: boolean = false;

  @Prop({ type: Boolean }) withFilter?: boolean;

  @lib.State(x => x.items) items!: string[];
  @lib.State(x => x.meta.counts) counts!: { all: number; filtered: number };

  @lib.State(x => x.map) itemInMap!: {
    [key: string]: {
      _id: string;
    };
  };
  mounted() {
    EventBus.$on('library-in-archive', (val: boolean) => {
      this.libraryInArchive = val;
    });
  }
}
